import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setMobileMenuVisibility } from '../../reducers/infrastructure';
import { history } from './../../configuration/store';
import { UserMenu } from './../menus';
import Notifications from '../notifications';
import { getAdminDetails } from '../../reducers/users';
import { isAdmin } from '../../utilities/roles';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';
import { setRoleSelectorVisibility } from '../../reducers/dialogs';

import './header.css';
import { getFullName } from '../../utilities/string';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.loadAdminData = this.loadAdminData.bind(this);
    }

    loadAdminData(props) {
        let { admin, details, role, getAdminDetails } = props;
        if (admin) return;

        if (isAdmin(role) && !admin) {
            getAdminDetails(role.id);
            return;
        }

        if (!details) return;
        getAdminDetails(details.admin_id);
    }

    componentDidMount() {
        this.loadAdminData(this.props);
    }

    componentDidUpdate() {
        this.loadAdminData(this.props);
    }

    render() {
        const {
            role,
            user,
            isAuthenticated,
            admin,
            size,
            menu,
            showHamburgerMenu,
            id,
            notifications,
            menuVisible,
            setMobileMenuVisibility,
            impersonatedUser,
            setRoleSelectorVisibility
        } = this.props;
        if (!isAuthenticated || !admin) {
            return null;
        }

        const { name, logo_url, logo_height, logo_width } = admin;
        const isSameRole = (r1, r2) => r1.id === r2.id && r1.type === r2.type;

        return (
            <div className="container-fluid header">
                {impersonatedUser &&
                    isSameRole(impersonatedUser.role, role) && (
                        <div className="impesonate-strip">
                            <i className="material-icons" onClick={() => setRoleSelectorVisibility(true, { role, cancelImpersonate: true })}>
                                close
                            </i>
                            <span>
                                <div className="impersonate-admin ellipsis">
                                    {`${user.given_name} ${user.family_name} `}
                                    <FormattedMessage {...messages.as} />
                                </div>
                                <div className="impersonate-target ellipsis">
                                    {impersonatedUser.role.role} - {getFullName(impersonatedUser)}
                                </div>
                            </span>
                        </div>
                    )}
                <div className="row">
                    <div className={size}>
                        {showHamburgerMenu ? (
                            <div className="col-xs-1 visible-xs mobile-menu-button" onClick={() => setMobileMenuVisibility(menuVisible === false)}>
                                <i className="material-icons">menu</i>
                            </div>
                        ) : null}
                        <div className="col-md-2 col-xs-5">
                            <div className="logo no-select" onClick={() => history.push('/')}>
                                {logo_url && logo_width && logo_height && <img src={logo_url} width={logo_width} height={logo_height} alt={name} />}
                            </div>
                        </div>

                        <div className="col-md-10 col-xs-6 pull-right">
                            <div className="pull-right">{menu && <UserMenu id={id} />}</div>
                            <div className="pull-right">{notifications && <Notifications />}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Header.defaultProps = {
    isAuthenticated: false,
    size: 'col-xs-12',
    menu: true,
    showHamburgerMenu: undefined,
    notifications: true
};

Header.propTypes = {
    isAuthenticated: PropTypes.bool,
    size: PropTypes.string,
    menu: PropTypes.bool,
    showHamburgerMenu: PropTypes.any,
    notifications: PropTypes.bool
};

const mapStateToProps = state => ({
    isAuthenticated: state.identity.isAuthenticated,
    menuVisible: state.infrastructure.menuVisible,
    user: state.identity.user,
    admin: state.users.adminDetails,
    details: state.identity.details,
    role: state.identity.role,
    impersonatedUser: state.identity.impersonatedUser
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setMobileMenuVisibility,
            getAdminDetails,
            setRoleSelectorVisibility
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/index.jsx